'use client';
import React, { FC, PropsWithChildren, useLayoutEffect } from 'react';

import { useOutsideClick } from '@/hooks/useOutsideClick';

import Portal from '../Portal';

interface ModalProps {
  showModal?: boolean;
  onClose?: () => void;
  title?: string;
  description?: string;
}

const Modal: FC<PropsWithChildren<ModalProps>> = ({
  title,
  onClose,
  children,
  showModal,
  description,
}) => {
  const popupRef = useOutsideClick<HTMLDivElement>(() => onClose?.());

  useLayoutEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showModal]);

  if (!showModal) {
    return null;
  }

  return (
    <Portal id="modal-container">
      <div className="popupWrp">
        <div className="popupInner contactMe" ref={popupRef}>
          <div className="popupInnerTitle">
            <div className="upcomingPopupTitleRow">
              <p className="upcomingPopupTitleText">{title}</p>
              <div className="upcomingPopupTitleCloseCont" onClick={() => onClose?.()}>
                <i className="bc-i-close upcomingPopupTitleCloseIcon" />
              </div>
            </div>
            <p className="popupInnerTitleInfo">{description}</p>
          </div>
          <div className="popupInnerContent">{children}</div>
        </div>
      </div>
    </Portal>
  );
};

export default Modal;
